var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelTraining2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 183,
    viewBox: "0 0 201 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 98.4279L1.0361 139.871V42.4794L100.5 1.03613L199.964 42.4794V139.871L100.5 98.4279Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.102 0.0796987C100.357 -0.0265662 100.643 -0.0265662 100.898 0.0796987L200.362 41.523C200.749 41.6839 201 42.0611 201 42.4794V139.871C201 140.218 200.827 140.541 200.539 140.733C200.25 140.925 199.885 140.961 199.565 140.828L100.5 99.5503L1.43458 140.828C1.11481 140.961 0.749604 140.925 0.461367 140.733C0.173131 140.541 0 140.218 0 139.871V42.4794C0 42.0611 0.251496 41.6839 0.637589 41.523L100.102 0.0796987ZM2.07217 43.1701V138.317L100.102 97.4715C100.357 97.3652 100.643 97.3652 100.898 97.4715L198.928 138.317V43.1701L100.5 2.1585L2.07217 43.1701Z",
    fill: "#031D60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0361 42.479L100.5 83.9223V181.314L1.0361 139.871V42.479Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.461367 41.6174C0.749604 41.4252 1.11481 41.3898 1.43458 41.5231L100.898 82.9664C101.285 83.1272 101.536 83.5045 101.536 83.9227V181.314C101.536 181.661 101.363 181.984 101.075 182.177C100.786 182.369 100.421 182.404 100.102 182.271L0.637589 140.828C0.251496 140.667 0 140.289 0 139.871V42.4794C0 42.133 0.173131 41.8095 0.461367 41.6174ZM2.07217 44.0336V139.18L99.4639 179.76V84.6135L2.07217 44.0336Z",
    fill: "#031D60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.964 42.479L100.5 83.9223V181.314L199.964 139.871V42.479Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.539 41.6174C200.827 41.8095 201 42.133 201 42.4794V139.871C201 140.289 200.748 140.667 200.362 140.828L100.898 182.271C100.579 182.404 100.214 182.369 99.9253 182.177C99.637 181.984 99.4639 181.661 99.4639 181.314V83.9227C99.4639 83.5045 99.7154 83.1272 100.101 82.9664L199.565 41.5231C199.885 41.3898 200.25 41.4252 200.539 41.6174ZM101.536 84.6135V179.76L198.928 139.18V44.0336L101.536 84.6135Z",
    fill: "#031D60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5412 65.2729L85.9948 94.2833V158.52L15.5412 129.51V65.2729Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9948 105.68L21.7577 132.618L15.5412 129.51V65.2729L85.9948 94.2833V105.68Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 125.007V74.4559C15.5 70.1861 19.8338 67.2827 23.7825 68.907L82.2825 92.9708C84.5318 93.8961 86 96.0876 86 98.5197V149.485C86 153.771 81.6372 156.674 77.6839 155.02L19.1839 130.542C16.9525 129.608 15.5 127.425 15.5 125.007Z",
    stroke: "url(#paint0_linear_2598_2866)",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 132.5L85 106",
    stroke: "url(#paint1_linear_2598_2866)",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2598_2866",
    x1: 79.2409,
    y1: 111.916,
    x2: 16.1057,
    y2: 108.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#021C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#012277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D0E84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2598_2866",
    x1: 79.1996,
    y1: 119.226,
    x2: 26.0568,
    y2: 111.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#021C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#012277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D0E84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelTraining2);
export default __webpack_public_path__ + "static/media/model-training-2.08683ea210905f68d9f3bf1fcc3ba4d9.svg";
export { ForwardRef as ReactComponent };